import Tab from '@mui/material/Tab';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Lanes } from './Lanes/Lanes';
import { LanesMap } from './Lanes/LanesMap/LanesMap';
import { Crosswalks } from './Crosswalks/Crosswalks';
import { CrosswalksMap } from './Crosswalks/CrosswalksMap/CrosswalksMap';
import { LANES_PATH, MANEUVERS_PATH, CROSSWALKS_PATH, LOCATION_CONFIG_PATH } from '../const';
import { Box, Card, Grid } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Maneuvers } from './Maneuvers/Maneuvers';
import { ManeuversMap } from './Maneuvers/ManeuversMap/ManeuversMap';
import clsx from 'clsx';
import { TabContext, TabList, TabPanel } from '@mui/lab';

const useStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    fullHeight: {
      height: '100%',
    },
    mapPanel: {
      height: '100%',
      padding: 0,
    },
    contentCard: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    formContainer: {
      overflow: 'auto',
      height: '100%',
      padding: `${spacing(2)} ${spacing(3)}`,
    },
    tabs: {
      paddingBottom: spacing(2),
      borderBottom: `${spacing(0.1)} solid ${palette.divider}`,
      position: 'relative',
      flex: 1,
    },
  });
});

const ConfigTabs = ({ tabPath }: { tabPath: string }) => {
  const { t } = useTranslation(['locations', 'common']);
  const classes = useStyles();
  return (
    <TabList className={classes.tabs}>
      <Tab
        label={t('common:lanes')}
        value={LANES_PATH}
        to={`${tabPath}${LOCATION_CONFIG_PATH}/${LANES_PATH}`}
        component={Link}
      />
      <Tab
        label={t('common:maneuvers')}
        value={MANEUVERS_PATH}
        to={`${tabPath}${LOCATION_CONFIG_PATH}/${MANEUVERS_PATH}`}
        component={Link}
      />
      <Tab
        label={t('crosswalks')}
        value={CROSSWALKS_PATH}
        to={`${tabPath}${LOCATION_CONFIG_PATH}/${CROSSWALKS_PATH}`}
        component={Link}
      />
    </TabList>
  );
};

const ConfigMaps = () => {
  const classes = useStyles();
  return (
    <>
      <TabPanel value={LANES_PATH} className={classes.mapPanel}>
        <LanesMap />
      </TabPanel>
      <TabPanel value={MANEUVERS_PATH} className={classes.mapPanel}>
        <ManeuversMap />
      </TabPanel>
      <TabPanel value={CROSSWALKS_PATH} className={classes.mapPanel}>
        <CrosswalksMap />
      </TabPanel>
    </>
  );
};

const ConfigForms = () => {
  return (
    <>
      <TabPanel value={LANES_PATH}>
        <Lanes />
      </TabPanel>
      <TabPanel value={MANEUVERS_PATH}>
        <Maneuvers />
      </TabPanel>
      <TabPanel value={CROSSWALKS_PATH}>
        <Crosswalks />
      </TabPanel>
    </>
  );
};

export const Configuration = ({
  tabPath,
  locationParams,
}: {
  tabPath: string;
  locationParams: { subTab?: string };
}) => {
  const classes = useStyles();
  const { subTab = LANES_PATH } = locationParams;

  return (
    <TabContext value={subTab}>
      <Grid className={classes.fullHeight} container spacing={2}>
        <Grid className={classes.fullHeight} item xs={12} xl={5}>
          <Card className={clsx(classes.fullHeight)}>
            <ConfigMaps />
          </Card>
        </Grid>
        <Grid className={classes.fullHeight} item xs={12} xl={7}>
          <Card className={classes.contentCard}>
            <ConfigTabs tabPath={tabPath} />
            <Box className={classes.formContainer}>
              <ConfigForms />
            </Box>
          </Card>
        </Grid>
      </Grid>
    </TabContext>
  );
};
